<style lang="scss">
  .date-picker-body {
    display: flex;
    flex-direction: column;
  }
</style>

<script>
  import TimeInputModalFooter from "../Modals/TimeInputModalFooter.svelte";
  import TimeInputModalHeader from "../Modals/TimeInputModalHeader.svelte";
  import { getDatePickerContext } from "./context.svelte.js";
  import DatePickerCalendar from "./DatePickerComponents/DatePickerCalendar.svelte";

  const datePickerContext = getDatePickerContext();

  const handleApply = () => {
    datePickerContext.applyPendingDate();
  };

  const handleCancel = () => {
    datePickerContext.showModal = false;
  };

  const handleDayClick = (clickedDay) => {
    datePickerContext.setPendingDate(clickedDay.fullDate);
  };
</script>

<div class="date-picker-body">
  <TimeInputModalHeader />
  <DatePickerCalendar {handleDayClick} />
  <TimeInputModalFooter onApply={handleApply} onCancel={handleCancel} />
</div>
